var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-inline-block alert alert-danger py-1 px-2 mb-0 font-weight-bold"},[_c('small',[_c('span',[_vm._v(_vm._s(_vm.notForSocialMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }